function toggleFooterMenu(menuId) {
  if (window.innerWidth >= 750) return;
  
  var menuList = $(`#${menuId}-list`);
  if (menuList.is(':visible')) {
    $(`#${menuId} .icon-arrow-right`).css('transform', 'rotate(0deg)');
  }
  else {
    $(`#${menuId} .icon-arrow-right`).css('transform', 'rotate(90deg)');
  }
  menuList.slideToggle(400);
}


function toggleDrawerMenu(menuId) {
  var menuList = $(`#${menuId}-list`);
  if (menuList.is(':visible')) {
    $(`#${menuId} .icon-arrow-right`).css('transform', 'rotate(0deg)');
  }
  else {
    $(`#${menuId} .icon-arrow-right`).css('transform', 'rotate(90deg)');
  }
  menuList.slideToggle(400);

  // close other menu
  $('#menu-drawer').find('.ace-menu-l2').not(menuList).slideUp(400);
  $('#menu-drawer').find('.icon-arrow-right').not($(`#${menuId} .icon-arrow-right`)).css('transform', 'rotate(0deg)');
}


function switchImage(productId, imageSrc, sectionId, varantUrl) {
  $('#media-' + productId + ' img').attr('src', imageSrc);
  $(`#CardLink-${ sectionId }-${ productId }`).attr('href', varantUrl);
  // console.log(`${productId} switch product's img: ${imageSrc}`);
}

function switchProductUnit(unit) {
  if (unit == 'metric') {
    $('#metric_button').addClass('full-unstyled-link');
    $('#imperial_button').removeClass('full-unstyled-link');
    $('#metric_unit').show();
    $('#imperial_unit').hide();
  } else {
    $('#imperial_button').addClass('full-unstyled-link');
    $('#metric_button').removeClass('full-unstyled-link');
    $('#imperial_unit').show();
    $('#metric_unit').hide();
  }
}